import React from 'react';

import { FormField } from 'fr-shared/components';

const FusingAgentFormField = props => {
  return (
    <FormField
      name="fusing_agent_consumption"
      label="Fusing Agent"
      type="number"
      append="cm^3"
      {...props}
    />
  );
};

export default FusingAgentFormField;
